module.exports = __webpack_public_path__ + "static/media/btnNext.794c22c4.svg";